import { useTranslation } from 'react-i18next';
import styles from './Menu.module.css';
import { useLocation, useNavigate } from 'react-router-dom';
import { useLucky6Access } from 'hooks/useLucky6Access';
import { useKenoAccess } from 'hooks/useKenoAccess';

export const Menu = () => {
  const { t } = useTranslation();
  const url = useLocation().pathname;
  const navigate = useNavigate();
  const lucky6 = useLucky6Access();
  const keno = useKenoAccess();

  return (
    <div className={styles.menuWrapper}>
      <ul>
        <li className={styles.menuItem}>
          <span
            onClick={() => navigate('/')}
            className={url === '/' ? styles.activeMenuitem : ''}
          >
            {t('home_label')}
          </span>
        </li>
        <li className={styles.menuItem}>
          <span
            onClick={() => navigate('/sports-betting')}
            className={url === '/sports-betting' ? styles.activeMenuitem : ''}
          >
            {t('sports_betting_label')}
          </span>
        </li>
        <li className={styles.menuItem}>
          <span
            onClick={() => navigate('/live-betting')}
            className={url === '/live-betting' ? styles.activeMenuitem : ''}
          >
            {t('live_betting_label')}
          </span>
        </li>
        <li className={styles.menuItem}>
          <span
            onClick={() => navigate('/casino-games')}
            className={url === '/casino-games' ? styles.activeMenuitem : ''}
          >
            {t('casino_games_label')}
          </span>
        </li>
        <li className={styles.menuItem}>
          <span
            onClick={() => navigate('/live-casino')}
            className={url === '/live-casino' ? styles.activeMenuitem : ''}
          >
            {t('live_casino_label')}
          </span>
        </li>
        {lucky6 && (
          <li className={styles.menuItem}>
            <span
              onClick={() => navigate('/lucky-six')}
              className={url === '/lucky-six' ? styles.activeMenuitem : ''}
            >
              {t('lucky_six_label')}
            </span>
          </li>
        )}
        {keno && (
          <li className={styles.menuItem}>
            <span
              onClick={() => navigate('/keno')}
              className={url === '/keno' ? styles.activeMenuitem : ''}
            >
              {t('keno_label')}
            </span>
          </li>
        )}
      </ul>
    </div>
  );
};
